<template>
  <v-navigation-drawer
    v-model="drawer.state"
    temporary
    hide-overlay
    right
    fixed
    :width="drawerWidth"
    class="nav-drawer"
    id="notification-drawer"
    @input="onStateChange"
    data-test-id="notification-panel"
  >
    <div>
      <v-toolbar elevation="0">
        <v-toolbar-title class="text-capitalize">{{
          drawerTitle
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <RhsMenu :showNotification="canShowNotification" parentDataTestId="notification-panel"/>
      </v-toolbar>
      <!-- Notification Drawer -->
      <div v-if="isNotificationDrawer">
        <NotificationFilters @filterSelected="filterSelected" />
        <v-divider class="mx-3"></v-divider>
        <NotificationsList :extraFilter="extraFilter" />
      </div>
      <!-- Help Drawer -->
      <Help v-else />
    </div>
  </v-navigation-drawer>
</template>
<script>
import RhsMenu from '../GlobalComponent/RhsMenu';
import NotificationFilters from './NotificationFilters';
import NotificationsList from './NotificationsList';
import Help from '../Help';
import { mapMutations, mapActions, mapState } from 'vuex';
export default {
  components: {
    NotificationFilters,
    NotificationsList,
    RhsMenu,
    Help
  },
  watch: {
    isNotificationDrawerOpen(newVal) {
      this.drawer = newVal;
      if (newVal?.state && newVal?.type === 'notification') {
        this.filterSelected(this.maxDuration, {});
      }
    },
    drawer: {
      handler(newVal) {
        this.setNotificationDrawer(newVal);
      },
      immediate: true
    }
  },
  data() {
    return {
      drawer: { state: false },
      maxDuration: 28,
      extraFilter: { showProgressOnly: false },
      drawerWidth: '450'
    };
  },
  computed: {
    ...mapState(['isNotificationDrawerOpen']),
    // To get title of drawer depending upon type of drawer
    drawerTitle() {
      return this.drawer?.type || '';
    },
    // Detecting for type of drawer is notification?
    isNotificationDrawer() {
      return this.drawer?.state && this.drawer?.type === 'notification';
    },
    canShowNotification() {
      return !this.$route.meta?.noMenuItems;
    }
  },
  methods: {
    ...mapMutations(['setNotificationDrawer']),
    ...mapMutations('notifications', ['setUserNotifications']),
    ...mapActions('notifications', ['getNotificationsForDuration']),
    onStateChange(val) {
      this.drawer = { state: val, type: this.drawer.type };
    },
    filterSelected(duration, extras) {
      this.extraFilter = extras;
      this.extraFilter.duration = duration;
    },
    /**
     * Getting notifications list data which includes unread count also
     */
    async getData() {
      try {
        // calculation epoch for {x}(means duration) days before
        const starteDate = this.getUTCDateAsPerTimeAndDate()
          .add(parseInt(this.maxDuration * -1), 'day')
          .startOf('day')
          .format('x');
        // calculation epoch for today
        const endDate = this.getUTCDateAsPerTimeAndDate().format('x');
        const requestObj = {
          from: +starteDate,
          order: 'DESC',
          pageNumber: 1,
          pageSize: 10,
          sortBy: 'TIMESTAMP',
          to: +endDate
        };
        // first making userNotifications empty then get notification data
        await this.setUserNotifications([]);
        await this.getNotificationsForDuration(requestObj);
      } catch (error) {
        this.snackbar('error', error);
      }
    }
  },
  mounted() {
    this.setNotificationDrawer(false);
    this.getData();
  }
};
</script>
<style scoped>
.nav-drawer {
  z-index: 12;
  align-items: center;
  padding-left: 25px;
  white-space: break-word;
}
</style>
